// extracted by mini-css-extract-plugin
module.exports = {"container":"search-input_container__3O0aR","icon":"search-input_icon__1C_dm","input":"search-input_input__2pytm","inputContainer":"search-input_inputContainer__FxBpC"};